<template>
  <v-container>
    <v-tabs
      v-model="tab"
      color="primary"
    >
      <v-tab>
        {{ $$t('edit')}}
      </v-tab>
      <v-tab>
        {{ $$t('overview')}}
      </v-tab>
    </v-tabs>
    <v-layout row wrap fill-height style="padding: 10px;">
      <v-flex fill-height d-flex xs12>

        <v-tabs-items v-model="tab" style="width: 100%">
          <v-tab-item>
            <ManageMapItems ref="mapItems" />
          </v-tab-item>
          <v-tab-item>
            <OverviewMapItem @selected="selectedMapItem" />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ManageMapItems from '../components/ManageMapItems.vue';
import OverviewMapItem from '../components/OverviewMapItem.vue';

export default
{
  components: { ManageMapItems, OverviewMapItem },
  name: 'Areas',
  module: 'Membership',
  data() {
    return {
      tab: 0,
      items: [
        'Appetizers', 'Entrees', 'Deserts', 'Cocktails',
      ],
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    };
  },
  methods: {
    selectedMapItem(mapItem) {
      this.tab = 0;
      this.$refs.mapItems.selectedMapArea = mapItem;
    },
  },
};
</script>
